import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './ui/assignee/__generated__/assigneeEditView_rootQuery$parameters';

const AssigneeEditViewEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-assignee-edit-view" */ './ui/assignee/index'),
	),
	getPreloadProps: () =>
		({
			queries: {
				rootData: {
					options: {
						fetchPolicy: 'store-or-network',
					},
					parameters,
					variables: {},
				},
			},
		}) as const,
});

export default AssigneeEditViewEntryPoint;
